import { render, staticRenderFns } from "./ScrapList.vue?vue&type=template&id=4c0a4b4c&scoped=true&"
import script from "./ScrapList.vue?vue&type=script&lang=js&"
export * from "./ScrapList.vue?vue&type=script&lang=js&"
import style0 from "./ScrapList.vue?vue&type=style&index=0&id=4c0a4b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a4b4c",
  null
  
)

export default component.exports